import React, { useRef, useEffect } from 'react';
import PricingSection from './pricingsection';
import ElegantDarkFeaturesSection from './Sonarfeature';
import TechnicalAdvantageSection from './TechnicalAdvantageSection';
import TestimonialsSection from './Sonar-testimonial';
import FAQSection from './FAQSection';
// import './Hon-sonar.css';

const HonSonar = () => {
  // const [activeTab, setActiveTab] = useState(1);
  // const [activeFaq, setActiveFaq] = useState(null);
  const containerRef = useRef(null);

  useEffect(() => {
    // Force document to be scrollable and remove default margins/padding
    document.body.style.overflow = 'auto';
    document.body.style.height = 'auto';
    document.body.style.margin = '0';
    document.body.style.padding = '0';
    document.documentElement.style.overflow = 'auto';
    document.documentElement.style.height = 'auto';
    document.documentElement.style.margin = '0';
    document.documentElement.style.padding = '0';
    
    const forceScrollableStyles = `
      html, body, #root, .App, .hon-sonar-page {
        overflow-y: auto !important;
        height: auto !important;
        min-height: 100% !important;
        position: relative !important;
        overscroll-behavior: auto !important;
        margin: 0 !important;
        padding: 0 !important;
      }
      /* Fix clickable elements */
      a, button, .clickable, [role="button"] {
        cursor: pointer !important;
        position: relative !important;
        z-index: 50 !important;
      }
      
      /* Make sure sections don't overlay and block clicks */
      section {
        position: relative !important;
        z-index: 1 !important;
      }
      
      /* Specific FAQ styles */
      .faq-item, .faq-header, .faq-toggle {
        cursor: pointer !important;
        position: relative !important;
        z-index: 50 !important;
      }
      
      /* Fix for any overlay elements */
      .absolute {
        pointer-events: none !important;
      }
      
      /* But allow clickable elements within absolute containers */
      .absolute a, .absolute button, .absolute [role="button"] {
        pointer-events: auto !important;
      }
      
      @media (max-width: 768px) {
        body {
          margin: 0 !important;
          padding: 0 !important;
        }
        
        .hon-sonar-page {
          margin-top: 0 !important;
          padding-top: 0 !important;
        }
        
        /* This targets any container that might be causing the issue */
        .container, header, nav, section:first-of-type {
          margin-top: 0 !important;
          padding-top: 0 !important;
        }
      }
    `;
    const styleEl = document.createElement('style');
    styleEl.type = 'text/css';
    styleEl.appendChild(document.createTextNode(forceScrollableStyles));
    document.head.appendChild(styleEl);
  
    return () => {
      document.body.style.overflow = '';
      document.body.style.height = '';
      document.body.style.margin = '';
      document.body.style.padding = '';
      document.documentElement.style.overflow = '';
      document.documentElement.style.height = '';
      document.documentElement.style.margin = '';
      document.documentElement.style.padding = '';
      document.head.removeChild(styleEl);
    };
  }, []);

  // You can keep your scrollToSection function as is
  // Enhanced scrollToSection function to ensure it works
  const scrollToSection = (id) => {
    console.log(`Attempting to scroll to section: ${id}`);
    const element = document.getElementById(id);
    if (element) {
      console.log(`Found element, scrolling to: ${id}`);
      element.scrollIntoView({ behavior: 'smooth' });
    } else {
      console.warn(`Element with id "${id}" not found`);
    }
  };
  
  // Force refresh any overlays that might be causing click issues
  useEffect(() => {
    const handleResize = () => {
      // This forces a reflow of the page, which can help with overlay issues
      if (containerRef.current) {
        containerRef.current.style.display = 'none';
        // Force reflow
        void containerRef.current.offsetHeight;
        containerRef.current.style.display = '';
      }
    };
    
    // Run once after initial render
    setTimeout(handleResize, 500);
    
    // Add listener for window resize
    window.addEventListener('resize', handleResize);
    
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div ref={containerRef} className="hon-sonar-page" style={{
      overflowY: 'auto',
      overflowX: 'hidden',
      width: '100%',
      height: 'auto',
      minHeight: '100vh',
      margin: '0',
      padding: '0',
      paddingTop: '0px',
      position: 'relative',
      zIndex: 1,
    }}>
      {/* Navbar Spacer */}
      <div style={{ height: '80px', backgroundColor: 'transparent' }}></div>

      {/* Hero Section */}
      <section
        className="relative bg-blue-900 text-white"
        style={{ marginTop: '100px !important', paddingTop: '20px !important' }}
      >
        <div className="absolute inset-0 z-0 pointer-events-none">
          <div className="absolute inset-0 bg-blue-900 opacity-90 pointer-events-none"></div>
        </div>

        <div className="container mx-auto px-4 pt-32 pb-20 relative z-10 ">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="space-y-6">
              <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight mt-4">
                <span className="text-white">
                  HON-SONAR™
                </span>
                <span className="block text-xl sm:text-2xl md:text-3xl mt-2 font-semibold text-white">Advanced Pattern Recognition Trading System</span>
              </h1>

              <p className="text-xl font-light leading-relaxed text-white max-w-xl">
                Harness the power of professional-grade pattern recognition with advanced algorithmic precision for consistent trading results.
              </p>

              <p className="text-lg italic text-blue-200">"Where human intuition meets algorithmic precision"</p>

              <div className="flex flex-col sm:flex-row gap-4 pt-4 mt-8 relative z-50">
                <a 
                  href="#pricing" 
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection('pricing');
                  }} 
                  className="inline-block px-6 py-3 bg-white text-indigo-600 font-semibold rounded-lg hover:bg-gray-100 transition shadow-lg relative z-50"
                  style={{ cursor: 'pointer', position: 'relative', zIndex: 100 }}
                >
                  Get Started Now
                </a>
                <a 
                  href="/journal" 
                  
                  className="inline-block px-6 py-3 bg-white text-indigo-600 font-semibold rounded-lg hover:bg-gray-100 transition shadow-lg relative z-50"
                  style={{ cursor: 'pointer', position: 'relative', zIndex: 100 }}
                >
                  See Results
                </a>
              </div>
            </div>

            <div className="relative">
              <div className="rounded-xl overflow-hidden shadow-2xl border border-indigo-500/30 relative">
                <div className="aspect-w-16 aspect-h-9 bg-blue-800 flex items-center justify-center p-8">
                  <div className="text-center">
                    <div className="text-3xl font-bold mb-4 text-white">HON-SONAR™ Dashboard</div>
                    <p className="text-blue-200">Advanced pattern recognition technology</p>
                  </div>
                </div>
              </div>

              <div className="absolute -bottom-6 -right-6 w-36 h-36 bg-gradient-to-br from-purple-600 to-indigo-600 rounded-full blur-3xl opacity-30"></div>
              <div className="absolute -top-6 -left-6 w-36 h-36 bg-gradient-to-br from-blue-600 to-cyan-600 rounded-full blur-3xl opacity-30"></div>
            </div>
          </div>

          <div className="absolute bottom-0 left-0 right-0">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" className="w-full">
              <path fill="#ffffff" fillOpacity="1" d="M0,224L48,213.3C96,203,192,181,288,181.3C384,181,480,203,576,218.7C672,235,768,245,864,229.3C960,213,1056,171,1152,165.3C1248,160,1344,192,1392,208L1440,224L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
            </svg>
          </div>
        </div>
      </section>
      
      {/* Pattern Preview Section */}
     
      <section className="py-24 bg-gradient-to-br from-gray-900 via-indigo-950 to-blue-950 text-white" id="patterns">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden">
        <div className="absolute top-20 right-20 w-64 h-64 bg-blue-500 rounded-full mix-blend-multiply opacity-10 filter blur-3xl"></div>
        <div className="absolute bottom-20 left-20 w-64 h-64 bg-indigo-500 rounded-full mix-blend-multiply opacity-10 filter blur-3xl"></div>
        
        {/* Circuit-like pattern overlay */}
        <svg className="absolute inset-0 w-full h-full opacity-5" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
          <pattern id="circuit" patternUnits="userSpaceOnUse" width="10" height="10">
            <path d="M0 5 L10 5 M5 0 L5 10" stroke="white" strokeWidth="0.5" fill="none" />
          </pattern>
          <rect width="100%" height="100%" fill="url(#circuit)" />
        </svg>
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-4xl mx-auto">
          {/* Glowing accent line */}
          <div className="w-24 h-1 bg-blue-500 rounded-full mx-auto mb-12 relative">
            <div className="absolute inset-0 bg-blue-400 rounded-full blur-sm"></div>
          </div>

          <div className="relative">
            {/* Main headline with glow effect */}
            <h2 className="text-3xl md:text-4xl font-bold mb-10 text-center leading-tight text-white">
              <span className="relative">
                <span className="relative z-10">HON-SONAR™ System: Precision-Powered AI for Market Pattern Recognition & Adaptive Trade Execution</span>
                <span className="absolute -inset-0.5 bg-gradient-to-r from-indigo-500 to-blue-500 opacity-20 blur-md z-0"></span>
              </span>
            </h2>

            {/* Main description */}
            <div className="space-y-6 relative">
              <div className="bg-white bg-opacity-10 backdrop-filter backdrop-blur-sm p-8 rounded-2xl border border-white border-opacity-10">
                <p className="text-xl leading-relaxed">
                  <span className="font-bold text-blue-300">HON-SONAR (Statistical Order-flow Network Analysis & Recognition)</span> is a next-generation algorithmic trading engine engineered for both retail and institutional use. Designed to detect statistically-reliable chart patterns, recognize evolving market regimes, and adapt in real-time across assets like forex, crypto, and commodities, the system transforms data into intelligent, actionable decisions.
                </p>
              </div>
            </div>
          </div>

          {/* Visual representation of key capabilities */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12">
            <div className="bg-gradient-to-br from-indigo-900 to-indigo-800 p-6 rounded-xl border border-indigo-700 transform transition hover:scale-105 relative group">
              <div className="absolute inset-0 bg-indigo-600 opacity-0 group-hover:opacity-10 transition rounded-xl"></div>
              <div className="h-12 w-12 rounded-lg bg-indigo-700 mb-4 flex items-center justify-center">
                <svg className="h-6 w-6 text-indigo-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 12l3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z" />
                </svg>
              </div>
              <h3 className="text-lg font-bold text-white mb-2">Pattern Recognition</h3>
              <p className="text-indigo-200 text-sm">13 high-probability chart patterns identified with precision accuracy</p>
            </div>

            <div className="bg-gradient-to-br from-blue-900 to-blue-800 p-6 rounded-xl border border-blue-700 transform transition hover:scale-105 relative group">
              <div className="absolute inset-0 bg-blue-600 opacity-0 group-hover:opacity-10 transition rounded-xl"></div>
              <div className="h-12 w-12 rounded-lg bg-blue-700 mb-4 flex items-center justify-center">
                <svg className="h-6 w-6 text-blue-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                </svg>
              </div>
              <h3 className="text-lg font-bold text-white mb-2">Market Adaptation</h3>
              <p className="text-blue-200 text-sm">Automatically adapts to changing market conditions in real-time</p>
            </div>

            <div className="bg-gradient-to-br from-purple-900 to-purple-800 p-6 rounded-xl border border-purple-700 transform transition hover:scale-105 relative group">
              <div className="absolute inset-0 bg-purple-600 opacity-0 group-hover:opacity-10 transition rounded-xl"></div>
              <div className="h-12 w-12 rounded-lg bg-purple-700 mb-4 flex items-center justify-center">
                <svg className="h-6 w-6 text-purple-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-lg font-bold text-white mb-2">Intelligent Execution</h3>
              <p className="text-purple-200 text-sm">Transforms analysis into precise, actionable trading decisions</p>
            </div>
          </div>
        </div>
      </div>
    </section>
      {/* Features Section */}
      <ElegantDarkFeaturesSection />
      
      {/* Advanced Technology Section */}
      <section className="py-20 bg-gradient-to-b from-blue-900 to-indigo-900 text-white" id="technology">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <span className="inline-block py-1 px-3 rounded-full bg-blue-800 text-blue-200 font-semibold text-sm mb-3">ADVANCED TECHNOLOGY</span>
              <h2 className="text-3xl md:text-4xl font-bold mb-6">Powered by Kalman Filtering Technology</h2>
              <p className="text-xl mb-6 text-blue-100">
                HON-SONAR™ employs sophisticated Kalman filtering algorithms—the same technology used in aerospace navigation and institutional quantitative models—to filter out market noise and identify cleaner, more reliable chart patterns.
              </p>
              
              <ul className="space-y-4">
                {[
                  "Reduces market noise for more accurate pattern detection",
                  "Creates cleaner price series for technical analysis",
                  "Improves pattern validation with advanced statistical techniques",
                  "Enhances entry and exit precision"
                ].map((item, index) => (
                  <li 
                    key={index}
                    className="flex items-start"
                  >
                    <span className="flex-shrink-0 h-6 w-6 rounded-full bg-indigo-500 flex items-center justify-center mt-1">
                      <svg className="h-3 w-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                      </svg>
                    </span>
                    <span className="ml-3">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
            
            <div className="relative">
              <div className="absolute inset-0 bg-blue-400 rounded-lg opacity-10 blur-3xl"></div>
              <div className="relative bg-gradient-to-br from-blue-800 to-indigo-900 rounded-xl overflow-hidden border border-blue-700 shadow-2xl">
                <div className="p-1 bg-gradient-to-r from-blue-500 to-indigo-500"></div>
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-4">Kalman Filter Visualization</h3>
                  <div className="aspect-w-16 aspect-h-9 bg-blue-800 rounded-lg overflow-hidden flex items-center justify-center p-6">
                    <div className="text-center">
                      <div className="text-blue-300 mb-2">Proprietary Algorithm</div>
                      <div className="text-sm text-blue-200">Our advanced filtering technology removes market noise to reveal true price patterns</div>
                    </div>
                  </div>
                  <div className="mt-4">
                    <p className="text-sm text-blue-200">
                      Kalman filtering removes market noise to reveal the true price trend, enabling more accurate pattern detection.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Technical Advantage - Enhanced */}
      <TechnicalAdvantageSection />
      {/* Results Section */}
       {/* PERFORMANCE header - moved to top of page */}
       <div className="bg-gradient-to-b from-gray-900 to-gray-800 pt-5 sm:pt-8 pb-2 relative border-b border-gray-700">
        <div className="absolute top-0 right-0 w-24 h-24 sm:w-36 sm:h-36 bg-indigo-900 rounded-full mix-blend-multiply opacity-20 filter blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-24 h-24 sm:w-36 sm:h-36 bg-blue-900 rounded-full mix-blend-multiply opacity-20 filter blur-3xl"></div>
        
        <div className="container mx-auto px-4 relative z-10">
          <div className="text-center">
            <div className="inline-flex items-center justify-center mb-3">
              <div className="h-0.5 w-6 sm:w-8 md:w-12 bg-indigo-400 mr-2 sm:mr-4"></div>
              <span className="py-1 px-3 rounded-full text-indigo-300 bg-indigo-900/60 font-semibold text-sm border border-indigo-700">PERFORMANCE</span>
              <div className="h-0.5 w-6 sm:w-8 md:w-12 bg-indigo-400 ml-2 sm:ml-4"></div>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold mb-4 text-white">Results That Speak Volumes</h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              HON-SONAR™ delivers consistent results across various market conditions by focusing on high-probability setups and protecting capital during unfavorable periods.
            </p>
            <p className="text-indigo-400 mt-4 text-sm font-medium mb-2">
              *Note: Past performance does not guarantee future results. Trading involves significant risk of loss.
            </p>
            
            {/* Bottom accent */}
            <div className="flex justify-center mt-3 mb-2">
              <div className="h-1 w-16 sm:w-20 md:w-24 bg-gradient-to-r from-indigo-500 to-blue-500 rounded-full"></div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Performance results section */}
      <section id="results" className="py-10 sm:py-16 bg-gradient-to-b from-gray-800 to-gray-900 text-white relative">
        <div className="absolute top-0 right-0 w-24 h-24 sm:w-48 sm:h-48 md:w-64 md:h-64 bg-indigo-900 rounded-full mix-blend-multiply opacity-20 filter blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-24 h-24 sm:w-48 sm:h-48 md:w-64 md:h-64 bg-blue-900 rounded-full mix-blend-multiply opacity-20 filter blur-3xl"></div>
        
        <div className="container mx-auto px-4 relative z-10">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-gradient-to-br from-indigo-900 to-blue-900 rounded-xl p-8 text-center relative overflow-hidden transform transition hover:scale-105">
              <div className="relative z-10">
                <h3 className="text-indigo-300 text-lg font-medium mb-3">Average Win Rate</h3>
                <div className="text-3xl sm:text-4xl md:text-5xl font-bold mb-2 text-white">78%</div>
                <p className="text-gray-300 text-sm">Range: 62%-78%*</p>
              </div>
              <div className="absolute -bottom-8 -right-8 w-48 h-48 bg-indigo-600 rounded-full opacity-10"></div>
            </div>

            <div className="bg-gradient-to-br from-indigo-900 to-blue-900 rounded-xl p-8 text-center relative overflow-hidden transform transition hover:scale-105">
              <div className="relative z-10">
                <h3 className="text-indigo-300 text-lg font-medium mb-3">Risk:Reward Ratio</h3>
                <div className="text-3xl sm:text-4xl md:text-5xl font-bold mb-2 text-white">1:3</div>
                <p className="text-gray-300 text-sm">Range: 1:1.5 to 1:3*</p>
              </div>
              <div className="absolute -bottom-8 -right-8 w-48 h-48 bg-indigo-600 rounded-full opacity-10"></div>
            </div>

            <div className="bg-gradient-to-br from-indigo-900 to-blue-900 rounded-xl p-8 text-center relative overflow-hidden transform transition hover:scale-105">
              <div className="relative z-10">
                <h3 className="text-indigo-300 text-lg font-medium mb-3">Monthly Return</h3>
                <div className="text-3xl sm:text-4xl md:text-5xl font-bold mb-2 text-white">12%</div>
                <p className="text-gray-300 text-sm">Range: 5%-30%*</p>
              </div>
              <div className="absolute -bottom-8 -right-8 w-48 h-48 bg-indigo-600 rounded-full opacity-10"></div>
            </div>
          </div>

          <div className="mt-16 bg-gradient-to-r from-indigo-800 to-blue-800 rounded-xl p-6 shadow-lg transform hover:shadow-xl transition duration-300">
            <div className="grid md:grid-cols-5 gap-y-4 md:gap-y-0 gap-x-4 text-center">
              {[
                { label: "Total Trades", value: "2,734" },
                { label: "Profitable", value: "2,132" },
                { label: "Max Drawdown", value: "8.2%" },
                { label: "Avg. Trade Duration", value: "26h" },
                { label: "Recovery Factor", value: "4.3" }
              ].map((stat, index) => (
                <div key={index} className="py-2">
                  <div className="text-2xl font-bold text-white">{stat.value}</div>
                  <div className="text-indigo-300 text-sm mt-1">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
          
          {/* Bottom accent */}
          <div className="flex justify-center mt-10">
            <div className="h-1 w-16 sm:w-20 md:w-24 bg-gradient-to-r from-indigo-500 to-blue-500 rounded-full"></div>
          </div>
        </div>
      </section>

      {/* Testimonials - Enhanced */}
     <TestimonialsSection />

      {/* Pricing Section */}
      <PricingSection />
      {/* FAQ Section - Enhanced */}
      <FAQSection/>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-indigo-600 to-purple-600 text-white" id="contact">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl md:text-4xl font-bold mb-6">Ready to Transform Your Trading?</h2>
            <p className="text-xl text-indigo-100 mb-8 max-w-2xl mx-auto">
              Join thousands of traders who have elevated their performance with HON-SONAR™'s advanced pattern recognition technology.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center relative z-50">
              <a 
                href="#pricing" 
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('pricing');
                }} 
                className="inline-block px-6 py-3 bg-white text-indigo-600 font-semibold rounded-lg hover:bg-gray-100 transition shadow-lg relative z-50"
                style={{ cursor: 'pointer', position: 'relative', zIndex: 100 }}
              >
                Get Started Now
              </a>
              <a 
                href="/contact" 
                className="inline-block px-6 py-3 bg-transparent text-white font-semibold rounded-lg border-2 border-white hover:bg-white/10 transition relative z-50"
                style={{ cursor: 'pointer', position: 'relative', zIndex: 100 }}
              >
                Contact Us
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HonSonar;